export default {"src":"/_next/static/media/drip.28c3849b.svg","height":20,"width":110,"blurWidth":0,"blurHeight":0};